import { useFormContext } from 'react-hook-form'

import { ReferenceInstrumentIdFormField } from '@/pages/trading/new-trade/fields/ReferenceInstrumentIdFormField'
import { ReferenceInstrumentTypeIdFormField } from '@/pages/trading/new-trade/fields/ReferenceInstrumentTypeIdFormField'
import {
  useInstrumentTypesQuery,
  useInstrumentsByTypeQuery,
} from '@/react-query/queries/instruments'

export interface CurrencyTradeFormFieldsProps {}

export const CurrencyTradeFormFields: React.FC<CurrencyTradeFormFieldsProps> = ({}) => {
  const { watch } = useFormContext<{ reference_instrument_type_id: number }>()
  const reference_instrument_type_id = watch('reference_instrument_type_id')

  const instrumentTypesQuery = useInstrumentTypesQuery()
  const instrumentsQuery = useInstrumentsByTypeQuery([reference_instrument_type_id])

  return (
    <div className={'flex items-center gap-4'}>
      <ReferenceInstrumentTypeIdFormField
        loading={instrumentTypesQuery.isFetching}
        instrumentTypes={instrumentTypesQuery.data}
      />
      <ReferenceInstrumentIdFormField
        loading={instrumentsQuery.isFetching}
        instruments={instrumentsQuery.data}
        disabled={!reference_instrument_type_id}
      />
    </div>
  )
}
